import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
// const Welcome = () => import('@/views/pages/Welcome')
const ChatFlow = () => import("@/views/pages/flow-builder/index");
const ChatAnalysis = () => import("@/views/pages/chat-analysis/index");
const MessageLog = () => import("@/views/pages/message-log/index");
const MessageLogDetail = () => import("@/views/pages/message-log/Details");
const SettingTime = () => import("@/views/pages/setting-time/index");
const SettingWidget = () => import("@/views/pages/setting-widget/Index");
const User = () => import("@/views/pages/user/Index");
const UserDetail = () => import("@/views/pages/user/Details");
const SentimentTraining = () =>
  import("@/views/pages/sentiment-training/index");
const FlowwayTraining = () =>
  import("@/views/pages/flowway-training/index");
const ImageMap = () => import("@/views/pages/image-map/index");
const EmailConfig = () => import("@/views/pages/email-config/Index");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Live = () => import("@/views/pages/live/Index");
const LiveDetail = () => import("@/views/pages/live/Detail");
const LiveEdit = () => import("@/views/pages/live/Edit");
const SettingIndex = () => import("@/views/pages/setting/Index");
const SettingBrand = () => import("@/views/pages/setting-brand/Index");
const ApiTrigger = () => import("@/views/pages/api-trigger/Index");
const ApiTriggerDetail = () => import("@/views/pages/api-trigger/Detail");
const Webhook = () => import("@/views/pages/webhook/Index");
const WebhookDetail = () => import("@/views/pages/webhook/Detail");
const Customer = () => import("@/views/pages/customer/Index");
const CustomerDetails = () => import("@/views/pages/customer/Detail");
const Variable = () => import("@/views/pages/variable/Index");
const SettingConfig = () => import("@/views/pages/setting-config/Index");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/",
      redirect: "/flow-builder",
      name: "HOME",
      component: TheContainer,
      meta: { requiresAuth: true },
      children: [
        {
          path: "/flow-builder",
          name: "FLOW BUILDER",
          component: ChatFlow,
          meta: { requiresAuth: true, activeUrl: "/flow-builder", parent: "/flow-builder", isChildren: true },
        },
        {
          path: "/chat-analysis",
          name: "CHAT ANALYSIS",
          component: ChatAnalysis,
          meta: { requiresAuth: true, activeUrl: "/chat-analysis", parent: "/chat-analysis", isChildren: true },
        },
        {
          path: "/image-map",
          name: "IMAGE MAP",
          component: ImageMap,
          meta: { requiresAuth: true, activeUrl: "/image-map", parent: "/image-map", isChildren: true },
        },
         {
          path: "/sentiment-training",
          name: "SENTIMENT TRAINING",
          component: SentimentTraining,
          meta: { requiresAuth: true, activeUrl: "/sentiment-training", parent: "/sentiment-training", isChildren: true },
        },
        {
          path: "/flowway-training",
          name: "FLOW WAY TRAINING",
          component: FlowwayTraining,
          meta: { requiresAuth: true, activeUrl: "/flowway-training", parent: "/flowway-training", isChildren: true },
        },
        {
          path: "/setting-time",
          name: "SETTING TIME LIST",
          component: SettingTime,
          meta: { requiresAuth: true, activeUrl: "/setting-time", parent: "/setting-time", isChildren: true },
        },
        {
          path: "/setting-widget",
          name: "SETTING WIDGET",
          component: SettingWidget,
          meta: { requiresAuth: true, activeUrl: "/setting-widget", parent: "/setting-widget", isChildren: true },
        },
        {
          path: "/email-config",
          name: "EMAIL CONFIG",
          component: EmailConfig,
          meta: { requiresAuth: true, activeUrl: "/email-config", parent: "/email-config", isChildren: true },
        },
         {
          path: "/setting",
          name: "SETTING",
          component: SettingIndex,
          meta: { requiresAuth: true, activeUrl: "/setting", parent: "/setting", isChildren: true, lv: 2 },
        },
        {
          path: "/setting-brand",
          name: "SETTING BRAND LIST",
          component: SettingBrand,
          meta: { requiresAuth: true, activeUrl: "/setting-brand", parent: "/setting-brand", isChildren: true, lv: 2 },
        },
        {
          path: "/setting-config",
          name: "SETTING CONFIG",
          component: SettingConfig,
          meta: { requiresAuth: true, activeUrl: "/setting-config", parent: "/setting-config", isChildren: true, lv: 2 },
        },
        {
          path: "/webhook",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/webhook" },
          children: [
            {
              path: "",
              name: "WEBHOOK LIST",
              component: Webhook,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/webhook" },
            },
            {
              path: "",
              redirect: "/webhook",
              name: "WEBHOOK LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "create",
                  name: "WEBHOOK CREATE",
                  component: WebhookDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/webhook" },
                },
                {
                  path: ":id",
                  name: "WEBHOOK DETAILS",
                  component: WebhookDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/webhook" },
                },
              ],
            },
          ]
        },
        {
          path: "/customer",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/customer" },
          children: [
            {
              path: "",
              name: "CUSTOMER LIST",
              component: Customer,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/customer" },
            },
            {
              path: "",
              redirect: "/customer",
              name: "CUSTOMER LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "detail/:id",
                  name: "CUSTOMER DETAILS",
                  component: CustomerDetails,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/customer" },
                },
              ],
            },
          ]
        },
        {
          path: "/message-log",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/message-log" },
          children: [
            {
              path: "",
              name: "MESSAGE LOG LIST",
              component: MessageLog,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/message-log" },
            },
            {
              path: "",
              redirect: "/message-log",
              name: "MESSAGE LOG LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "details/:id/:collection",
                  name: "MESSAGE LOG DETAILS",
                  component: MessageLogDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/message-log" },
                },
              ],
            },
          ]
        },
        {
          path: "/chat",
          name: "CHAT",
          meta: { requiresAuth: true, activeUrl: "/chat", parent: "/chat", lv: 1 },
        },
        {
          path: "/user",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/user" },
          children: [
            {
              path: "",
              name: "USER LIST",
              component: User,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/user" },
            },
            {
              path: "",
              redirect: "/user",
              name: "USER LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "details/:id",
                  name: "USER DETAILS",
                  component: UserDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/user" },
                },
              ],
            },
          ]
        },
        {
          path: "/api-trigger",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/api-trigger" },
          children: [
            {
              path: "",
              name: "API TRIGGER LIST",
              component: ApiTrigger,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/api-trigger" },
            },
            {
              path: "",
              redirect: "/api-trigger",
              name: "API TRIGGER LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "create",
                  name: "API TRIGGER CREATE",
                  component: ApiTriggerDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/api-trigger" },
                },
                {
                  path: ":id",
                  name: "API TRIGGER DETAILS",
                  component: ApiTriggerDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/api-trigger" },
                },
              ],
            },
          ]
        },
        {
          path: "/live",
          name: "",
          component: { render(c) { return c("router-view"); } },
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/live" },
          children: [
            {
              path: "",
              name: "LIVE LIST",
              component: Live,
              meta: { requiresAuth: true, isChildren: true, activeUrl: "/live" },
            },
            {
              path: "",
              redirect: "/live",
              name: "LIVE LIST",
              component: { render(c) { return c("router-view"); } },
              children: [
                {
                  path: "detail/:id",
                  name: "LIVE DETAILS",
                  component: LiveDetail,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/live" },
                },
                {
                  path: "create/:postTypeId/:id",
                  name: "LIVE CREATE",
                  component: LiveEdit,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/live" },
                },
                {
                  path: "edit/:postTypeId/:id",
                  name: "LIVE EDIT",
                  component: LiveEdit,
                  meta: { requiresAuth: true, isChildren: true, activeUrl: "/live" },
                },
              ],
            },
          ]
        },
        {
          path: "/variable",
          name: "VARIABLE LIST",
          component: Variable,
          meta: { requiresAuth: true, isChildren: true, activeUrl: "/variable" },
        },
        {
          path: "/500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "/400",
          name: "Page404",
          component: Page404,
        },
        {
          path: "*",
          name: "Page404",
          component: Page404,
        },
      ],
    },
  ],
});
